import theme from './materialTheme/index.js';

const AVATAR_COLORS = [
  theme.palette.primary.main,
  theme.palette.secondary.dark,
  // Some nice colors that go with our theme but do not look like errors
  '#B551A9',
  '#E08E5B'
];

/**
 * Pick a color for an avatar (for a user, project, etc.)
 * Using a unique ID will make the color random but consistent so that it can
 * be recognized with repeated exposure. It also means avatars with the same
 * letter do not always have the same color.
 */
export const pickAvatarColor = (id: string) => {
  return AVATAR_COLORS[id.charCodeAt(0) % AVATAR_COLORS.length];
};
